<template>
    <div>
        <div class="dialog-login" v-if="login_visible">
            <div class="hd">
                <div class="bg"></div>
                <img src="../../assets/images/login/logo.png" alt="" class="logo">
                <h3>用户登录</h3>
                <i class="el-icon-close close" @click="clickClose"></i>
            </div>
            <div class="bd">
                <div class="item">
                    <img src="../../assets/images/login/icon_01.png" alt="" class="i"/>
                    <el-input class="user" v-model="ruleForm.username" placeholder="请输入用户账号"></el-input>
                </div>
                <div class="item">
                    <img src="../../assets/images/login/icon_02.png" alt="" class="i"/>
                    <el-input class="pwd" v-model="ruleForm.password" type="password" placeholder="请输入用户密码">                    
                    </el-input>
                </div>
                <div class="submit">
                    <div class="tips tips-success" v-if="validate_status == 1"><img src="../../assets/images/login/success.png" alt="" >{{tips}}</div>
                    <div class="tips tips-error" v-if="validate_status == 2"><img src="../../assets/images/login/error.png" alt="" >{{tips}}</div>
                    <el-button class="button" @click="clickLoginSubmit" :loading="loading">立即登录</el-button>
                </div>
                <div class="jump">
                    还没有用户账号？<a href="javascript:;" @click="showReg">立即注册</a>
                </div>
            </div>
        </div>

        <div class="dialog-login dialog-reg" v-if="reg_visible">
            <div class="hd">
                <div class="bg"></div>
                <img src="../../assets/images/login/logo.png" alt="" class="logo">
                <h3>用户注册</h3>
                <i class="el-icon-close close" @click="clickClose"></i>
            </div>
            <div class="bd">
                <div class="item2">
                    <el-input class="" v-model="regForm.username" placeholder="请输入要注册的账号"></el-input>
                    <div class="msg">注册帐号是您的电话号码</div>
                </div>
                <div class="item2">
                    <el-input class="" v-model="regForm.password" type="password" placeholder="请输入密码">                    
                    </el-input>
                    <div class="msg">
                        密码需以6-12位字母和数字组合的密码
                    </div>
                </div>
                <div class="item2">
                    <el-input class="pwd" v-model="regForm.password2" type="password" placeholder="请再次输入密码">                    
                    </el-input>
                    <div class="msg">
                        密码需以6-12位字母和数字组合的密码
                    </div>
                </div>
                <div class="submit">
                    <div class="tips tips-success" v-if="validate_status == 1"><img src="../../assets/images/login/success.png" alt="" >{{tips}}</div>
                    <div class="tips tips-error" v-if="validate_status == 2"><img src="../../assets/images/login/error.png" alt="" >{{tips}}</div>
                    <el-button class="button" @click="clickRegSubmit" :loading="loading">立即注册</el-button>
                </div>
                <div class="jump">
                    已有账号？<a href="javascript:;" @click="showLogin">立即登录</a>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import { login,getUser,register } from '@/api/user.js';
    export default {
        data() {
            return { 
                loading: false,
                tips: "",
                validate_status: 0,
                ruleForm: {
                    username: "",
                    password: ""
                },
                regForm: {
                    username: "",
                    password: "",
                    password2: ""
                },
                login_visible: true,
                reg_visible: false
            }
        },
        methods: {
            showLogin() {
                this.login_visible = true;
                this.reg_visible = false;
                this.tips = "";
                this.validate_status = 0;
            },
            showReg() {
                this.login_visible = false;
                this.reg_visible = true;
                this.tips = "";
                this.validate_status = 0;
            },
            clickClose() {
                this.login_visible = false;
                this.reg_visible = false;
                this.tips = "";
                this.validate_status = 0;
                this.ruleForm = {
                    username: "",
                    password: ""
                };
                this.regForm = {
                    username: "",
                    password: "",
                    password2: ""
                };
            },
            clickRegSubmit() {
                if(this.loading) {
                    return;
                }
                if(this.regForm.username == "") {
                    this.validate_status = 2;
                    this.tips = "请输入要注册的账号";
                } else if(this.regForm.password == "") {
                    this.validate_status = 2;
                    this.tips = "请输入密码";
                }  else if(this.regForm.password == "") {
                    this.validate_status = 2;
                    this.tips = "请再次输入密码";
                }  else if(this.regForm.password2 == "" != this.regForm.password) {
                    this.validate_status = 2;
                    this.tips = "两次输入密码不一致";
                } else {
                    this.loading = true;
                    this.validate_status = 0; 
                    register(this.regForm.username,this.regForm.password,this.regForm.password2).then((response)=>{
                        this.tips = response.data.msg;
                        this.loading = false;
                        if (response.data.code == 200) {
                            this.validate_status = 1;                            
                            window.localStorage.setItem("userToken", response.data.data.token);
                            this.$store.commit('SET_TOKEN', response.data.data.token);
                            getUser();
                        }else {
                            this.validate_status = 2;
                        }
                    })
                }                
            },
            clickLoginSubmit() {
                if(this.loading) {
                    return;
                }
                if(this.ruleForm.username == "") {
                    this.validate_status = 2;
                    this.tips = "请输入用户账号";
                } else if(this.ruleForm.password == "") {
                    this.validate_status = 2;
                    this.tips = "请输入用户密码";
                } else {
                    this.loading = true;
                    this.validate_status = 0; 
                    login(this.ruleForm.username,this.ruleForm.password).then((response)=>{
                        this.tips = response.data.msg;
                        this.loading = false;
                        if (response.data.code == 200) {
                            this.validate_status = 1;                            
                            window.localStorage.setItem("userToken", response.data.data.token);
                            this.$store.commit('SET_TOKEN', response.data.data.token);
                            getUser();
                        }else {
                            this.validate_status = 2;
                        }
                    })
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        
                        
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style lang="scss">
    .dialog-login {
        width: 455px;
        min-height: 450px;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 6px 20px #7E5223;
        padding-bottom: 30px;
        box-sizing: border-box;
        .hd {
            height: 185px;
            position: relative;
            text-align: center;
            .bg {
                background: linear-gradient(#CD9447, #784D20);
                height: 70px;
                position: absolute;
                width: 100%;
                z-index: 1;
            }
            .logo {
                display: inline-block;
                width: 105px;
                height: 105px;
                border-radius: 20px;
                margin-top: 25px;
                position: relative;
                z-index: 11;
            }
            h3 {
                color: #9a681f;
                font-size: 30px;
                font-weight: 400;
                font-family: "微软雅黑";
            }
            .close {
                font-size: 30px;
                top: 15px;
                right: 20px;
                position: absolute;
                color: #fff;
                z-index: 11;
                cursor: pointer;
            }
        }
        .bd {
            width: 320px;
            margin: 0 auto;
            .item {
                position: relative;
                & + .item {
                    margin-top: 20px;
                }
                .el-input__inner {
                    padding-left: 35px;
                }
                .i {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    z-index: 1;
                }
            }
            .item2 {
                .msg {
                    padding: 3px 10px;
                    color:#cbb48b;
                }
            }
            .el-input__inner {
                border-color: #CDA661;
            }
            .submit {
                position: relative;
                .tips {
                    position: absolute;
                    width: 100%;
                    top: 4px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 12px;
                    img {
                        margin-right: 5px;
                    }
                }
                .tips-success {
                    color: #4ab503;
                }
                .tips-error {
                    color: #ff2929;
                }
                .button {
                    margin-top: 25px;
                    background: linear-gradient(#B5781F, #7B4F20);
                    box-shadow: 0 6px 20px #7E5223;
                    color: #fff;
                    height: 50px;
                    line-height: 50px;
                    font-size: 18px;
                    font-family: "微软雅黑";
                    border-color: #7B4F20;
                    width: 100%;
                    padding: 0;
                    &:hover {
                        opacity: 0.9;
                    }
                }
            }
            .jump {
                margin-top: 25px;
                font-size: 14px;
                text-align: center;
                color: #9a681f;
                a {
                    color: #ff2929;
                    text-decoration: underline;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue